<template>
  <div v-if="Array.isArray(safeGroups) && safeGroups.length" class="labels-card">
    <div v-for="(group, index) in safeGroups" :key="group.title || index" class="label-group">
      <h3 v-if="group.title" class="group-title">{{ group.title }}</h3>
      <div v-if="group.labels && group.labels.length" class="labels-container">
        <span v-for="(label, labelIndex) in group.labels" :key="labelIndex" class="label-tag">
          {{ label }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LabelsCard',
  props: {
    // 支持多种结构的 value，避免渲染时报错
    value: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    safeGroups() {
      if (!this.value) return []

      // 标准化为数组
      const list = Array.isArray(this.value) ? this.value : [this.value]

      return list
        .filter(item => item !== null && item !== undefined)
        .map(item => {
          // 兼容直接传字符串 / 数字
          if (typeof item === 'string' || typeof item === 'number') {
            return {
              title: String(item),
              labels: [],
            }
          }

          // 兼容对象结构缺少 title / labels 的情况
          const title = item && item.title ? String(item.title) : ''
          const labels = Array.isArray(item && item.labels) ? item.labels : []

          return {
            title,
            labels,
          }
        })
    },
  },
}
</script>

<style scoped>
.labels-card {
  padding: 16px;
  background-color: #fff;
}

.label-group {
  margin-bottom: 32px;
}

.label-group:last-child {
  margin-bottom: 0;
}

.group-title {
  margin: 0 0 16px 0;
  font-size: 30px;
  font-weight: 600;
  color: #333;
  line-height: 1.5;
}

.labels-container {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.label-tag {
  display: inline-block;
  padding: 8px 16px;
  background-color: #f5f5f5;
  color: #333;
  border-radius: 20px;
  font-size: 25px;
  white-space: nowrap;
  line-height: 1.4;
}

/* 平板及以上屏幕优化 */
@media (min-width: 768px) {
  .labels-card {
    padding: 20px;
  }

  .label-group {
    margin-bottom: 28px;
  }

  .group-title {
    font-size: 30px;
    margin-bottom: 14px;
  }

  .label-tag {
    font-size: 25px;
    padding: 7px 14px;
  }

  .labels-container {
    gap: 10px;
  }
}
</style>
